import {
   CustomButton,
   CustomTextArea,
   FormSelect,
} from '../../../../../components';
import { Col, Row } from 'antd';
import { PlusOutlined } from '@ant-design/icons';


const GestorStatusEntry = ({
   entryStates,
   formikSolicitud,
   handleTextValue,
   textValue,
   manageMyRequest
}: any) => {
   const handleBtnAdd = () => {
      handleTextValue(formikSolicitud.values.reason);
   };
   const handleGestor = () => {
      let listOptions: any = []
      if (manageMyRequest) {
         entryStates.filter((state: any) => {
            if (state.name === "Devuelto" || state.name === "Trámite de ingreso") {
               listOptions.push({
                  ...state,
                  disabled: state.name === "Devuelto",
               })
            }
         })
      } else {
         listOptions = entryStates.filter((state: any) => state.id === 12 || state.id === 5)
      }

      return listOptions
   }
   return (
      <>
         <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={6}>
               <FormSelect
                  label="Estado de la solicitud"
                  name="status_id"
                  placeholder="Seleccione"
                  value={formikSolicitud.values.status_id}
                  options={handleGestor()}
                  error={formikSolicitud.errors.status_id}
                  touched={formikSolicitud.touched.status_id}
                  onChange={(value) =>
                     formikSolicitud.setFieldValue('status_id', value)
                  }
                  onBlur={formikSolicitud.handleBlur}
               />
            </Col>
         </Row>
         <Row gutter={[16, 16]}>
            <Col xs={24}>
               <CustomTextArea
                  label="Motivo*"
                  name="reason"
                  placeholder="Inserte"
                  value={
                     formikSolicitud.values.reason
                  }
                  error={formikSolicitud.errors.reason}
                  touched={formikSolicitud.touched.reason}
                  onChange={formikSolicitud.handleChange}
                  onBlur={formikSolicitud.handleBlur}
               />
            </Col>
         </Row>
         <Row gutter={[16, 16]} justify="end">
            <Col xs={24} sm={12} md={8} lg={4}>
               <CustomButton
                  label={textValue ? 'Actualizar' : 'Añadir'}
                  onClick={() => handleBtnAdd()}
                  size="middle"
                  icon={<PlusOutlined />}
               />
            </Col>
         </Row>
      </>
   );
};

export default GestorStatusEntry;
